import { render, staticRenderFns } from "./NewGames.vue?vue&type=template&id=31f6e2c6&scoped=true&"
import script from "./NewGames.vue?vue&type=script&lang=js&"
export * from "./NewGames.vue?vue&type=script&lang=js&"
import style0 from "./NewGames.vue?vue&type=style&index=0&id=31f6e2c6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f6e2c6",
  null
  
)

export default component.exports